module.exports = __webpack_public_path__ + "static/media/21.75975838.jpg";